import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Formats a number to exactly 2 decimal places for currency display (net, cash out)
 * @param value - The numeric value to format
 * @returns Formatted string with 2 decimal places (e.g., "22.00", "-15.50")
 */
export function formatCurrency(value: number | null | undefined): string {
  if (value === null || value === undefined || isNaN(value)) {
    return '0.00';
  }
  return value.toFixed(2);
}

/**
 * Rounds a number to 2 decimal places for calculations
 * Prevents floating point precision issues
 * @param value - The numeric value to round
 * @returns Rounded number to 2 decimal places
 */
export function roundToTwoDecimals(value: number): number {
  return Math.round(value * 100) / 100;
}

/**
 * Appends a new note to an existing one using the '|' separator.
 * Ensures no leading/trailing separators if one of the strings is empty.
 * @param existing - The existing note string
 * @param additional - The new note to append
 * @returns Combined note string
 */
export function appendNote(existing: string | null | undefined, additional: string | null | undefined): string {
  const base = (existing || '').trim();
  const extra = (additional || '').trim();
  
  if (!extra) return base;
  if (!base) return extra;
  
  // Avoid duplicating the exact same note if it's already there
  if (base === extra || base.endsWith(`| ${extra}`)) return base;
  
  return `${base} | ${extra}`;
}
